/**
 * Lightbox — click a [data-rh-zoom] figure to view its image full-screen.
 * Dependency-free. Closes on overlay click, the close button, or Escape.
 */
((Drupal) => {
  Drupal.behaviors.rhinoLightbox = {
    attach(context) {
      const triggers = once('rh-zoom', '[data-rh-zoom]', context);
      if (!triggers.length) return;

      let overlay = null;

      const onKey = (e) => {
        if (e.key === 'Escape') close();
      };

      function close() {
        if (!overlay) return;
        overlay.remove();
        overlay = null;
        document.removeEventListener('keydown', onKey);
      }

      function open(trigger) {
        const media = trigger.querySelector('img, svg');
        if (!media || overlay) return;

        overlay = document.createElement('div');
        overlay.className = 'rh-lightbox';

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'rh-lightbox__close';
        btn.setAttribute('aria-label', Drupal.t('Close'));
        btn.innerHTML = '&times;';

        const clone = media.cloneNode(true);
        clone.removeAttribute('width');
        clone.removeAttribute('height');
        clone.removeAttribute('loading');
        clone.style.transform = '';
        clone.className = 'rh-lightbox__media';

        overlay.appendChild(btn);
        overlay.appendChild(clone);
        overlay.addEventListener('click', close);
        document.body.appendChild(overlay);
        document.addEventListener('keydown', onKey);
      }

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => open(trigger));
        trigger.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            open(trigger);
          }
        });
      });
    },
  };
})(Drupal);
